import Button from "../button/Button";

/**
 * StepFlow シェル（ヘッダー / 本文 / フッター）の定数とフッターアクションの描画。
 * コンポーネント本体は `StepFlowShell.tsx`、ページ型レイアウトは `StepFlowLayout.tsx`。
 */

/** 本文・フッターの幅上限（px）。`.u-wrapper-reading` の 740 に揃える */
export const STEP_FLOW_CONTENT_MAX_WIDTH = 740;
/** ヘッダー中央（ステップナビ）の幅上限（px） */
export const STEP_FLOW_STEPPER_MAX_WIDTH = 480;

export interface StepFlowAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  leftIcon?: string;
  rightIcon?: string;
  /** 右（次へ）の既定は "primary"、左（戻る）の既定は "tertiary" */
  theme?: "primary" | "secondary" | "tertiary";
  variant?: "filled" | "outlined" | "text";
  /**
   * 表示時に初期フォーカスを当てる。確認モーダルでは安全側（キャンセル）に渡し、
   * 誤って Enter で破壊的操作が走るのを防ぐ。
   */
  autoFocus?: boolean;
}

export const renderStepFlowAction = (
  action: StepFlowAction,
  defaultTheme: StepFlowAction["theme"],
  defaultVariant: "filled" | "outlined" | "text",
  size: "large" | "medium" | "small",
) => {
  // autoFocus が当たるアクションは視覚的にも強調するため primary + filled にする
  const theme = action.autoFocus ? "primary" : (action.theme ?? defaultTheme);
  const buttonVariant = action.autoFocus ? "filled" : (action.variant ?? defaultVariant);
  return (
    <Button
      size={size}
      theme={theme}
      variant={buttonVariant}
      onClick={action.onClick}
      disabled={action.disabled || action.loading}
      leftIcon={action.leftIcon}
      rightIcon={action.rightIcon}
      autoFocus={action.autoFocus}
    >
      {action.loading ? "送信中..." : action.label}
    </Button>
  );
};
